import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React, { useState } from 'react';
import ButtonPanel from '../../../common/ButtonPanel';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonPanelContainer: {
      display: 'flex',
      justifyContent: 'center',
      margin: '0 -8px 16px -8px'
    },
  })
);

interface Props {
  onClose: (fileType?: string) => void;
}

function DownloadWorkflowDialog(props: Props) {
  const { onClose } = props;
  const classes = useStyles({});
  const [fileType, setFileType] = useState(null);

  return (<Dialog
    open={true}
    onClose={() => onClose()}
    aria-labelledby="download-workflow-dialog-title"
    aria-describedby="download-workflow-dialog-description"
    fullWidth
    maxWidth="xs"
  >
    <DialogTitle id="download-workflow-dialog-title">Which format would you like to download?</DialogTitle>
    <DialogContent>
      <div className={classes.buttonPanelContainer}>
        <ButtonPanel selected={fileType === 'yaml'} onClick={() => setFileType('yaml')}>
          <Typography variant="subtitle1">YAML</Typography>
        </ButtonPanel>
        <ButtonPanel selected={fileType === 'json'} onClick={() => setFileType('json')}>
          <Typography variant="subtitle1">JSON</Typography>
        </ButtonPanel>
      </div>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => onClose()} color="primary">
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        disabled={!fileType}
        onClick={() => onClose(fileType)}>
        Download
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default DownloadWorkflowDialog;
